export const oauthGrantTypes = {
    REFRESH_TOKEN: 'refresh_token',
    AUTHORIZATION: 'authorization_code'
};
export const oauthTokenTypes = {
    ACCESS: 'access_token',
    REFRESH: 'refresh_token'
};
export const OBTAIN_TOKENS_REQUEST_ID = 'GEF_OBTAIN_TOKENS_REQUEST_ID';
